import { useEffect, useState } from 'react';

export const useResizeListener = () => {
  const [isResize, setIsResize] = useState(false);

  const onResize = () => {
    if (window.outerWidth > 0) {
      setIsResize(true);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return isResize;
};
